import actions from '../../actions/MedicalBenefitsSets'
import { connectPlanSharedBusinessRules } from '../PlanSharedBusinessRules/CreateBusinessRulesShow'

export default connectPlanSharedBusinessRules('Medical', actions.show.main, actions.show.reset)
